import { render } from "./CareSeekerStaff.vue?vue&type=template&id=4099a4a5&scoped=true"
import script from "./CareSeekerStaff.vue?vue&type=script&lang=js"
export * from "./CareSeekerStaff.vue?vue&type=script&lang=js"

import "./CareSeekerStaff.vue?vue&type=style&index=0&id=4099a4a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4099a4a5"]])

export default __exports__